import { Component, OnInit, ViewChild, Input, TemplateRef } from '@angular/core';
import { apiService } from '../../../../../../service/api.service';
import { ResponseOtrasCuentasModel, CuentasModel, EncargadoRegionalModel, ResponseEncargadoRegionalModel } from '../../../../../../model/Cuentas.model'
import { MatPaginator, PageEvent} from '@angular/material/paginator';
import { MatSort} from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog'; 
import { NgxSpinnerService } from "ngx-spinner";
import { environment } from 'src/environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { formatRut, validateRut } from '@fdograph/rut-utilities';

@Component({
  selector: 'app-cuentas-encargado-regional',
  templateUrl: './cuentas-encargado-regional.component.html',
  styleUrls: ['./cuentas-encargado-regional.component.css']
})
export class CuentasEncargadoRegionalComponent implements OnInit {

  @ViewChild('modalFromAsesorTecnico', { static: true }) modalFromAsesorTecnico: TemplateRef<any>;
  filterValues = {}; 
  filterSelectObjOtros = []; 
  //displayedColumns=[];
  displayedColumnsOtrasCuentas=[];
  apiEndpoint = environment.apiEndpoint;
  dataSourceOtrasCuentas: MatTableDataSource<EncargadoRegionalModel>;
  columnNamesOtrasCuentas = [
    { id: 'region', value: 'region' }, 
    { id: 'nombres', value: 'nombres' }, 
    { id: 'apellidos', value: 'apellidos' }, 
    { id: 'correo', value: 'correo' }, 
    { id: 'usuario', value: 'usuario' }, 
    { id: 'password', value: 'password' }, 
    { id: 'bloqueo', value: 'bloqueo' }, 
    { id: 'acciones', value: 'acciones' }, 
  ];


  pageEvent: PageEvent;
  pageIndex:number;
  palabraClave: string;
  idRegion:number;
  idComuna:number;
  idPrograma:number;
  length:number;
  arrayComunas = [];

  validacionRut:boolean=false;
  validacionNombres:boolean=false;
  validacionApellido1:boolean=false;
  validacionApellido2:boolean=false;
  validacionEmail:boolean=false;
  validacionRegion:boolean=false;
  editar:boolean=false;

  encargadoRecionalModel : EncargadoRegionalModel;

  
  @ViewChild(MatPaginator, {read: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @Input() infoSelectJardin: CuentasModel;
  constructor(
    private api: apiService,
    public dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private modal: NgbModal,
  ) { }

  ngOnInit(): void {
    this.defaultValidation();
    this.palabraClave = "";
    this.idRegion = 0;
    this.idComuna = 0;
    this.idPrograma = 0;
    this.getServerData();
  }

  public getServerData(event?:PageEvent){
    this.callData(event != null ? event : null ,null);
  }

  public callData(event?:PageEvent,palabraClave?:string){
    this.spinner.show();
    let pageNum = event != null ? (event.pageIndex + 1) : 1;
    let pageSize = event != null ? event.pageSize : 10;
    this.api.API_POST_getEncargadosRegionales(pageNum,pageSize,this.palabraClave,this.idRegion,this.idComuna,this.idPrograma).subscribe((response: ResponseEncargadoRegionalModel) => {
      this.displayedColumnsOtrasCuentas = this.columnNamesOtrasCuentas.map(x => x.id);
      this.dataSourceOtrasCuentas = new MatTableDataSource<EncargadoRegionalModel>(response.payload.list);
      this.pageIndex = (response.payload.pageNum - 1);
      this.length = response.payload.total;

      setTimeout(() => {
        
        this.dataSourceOtrasCuentas.paginator = this.paginator;
        this.spinner.hide();

      }, 1000);
        
    },
    (err) => {
      console.log("error"+err)
    })
  }


  buscar(palabraClave){
    this.palabraClave = palabraClave;
    this.callData(null);
  }


  editarCuenta(row:EncargadoRegionalModel, position){ 
    this.encargadoRecionalModel = row;
    this.editar=true;
    this.modal.open(this.modalFromAsesorTecnico, { size: 'lg' });
  }

  bloquear(row:any, tipo: string){
    this.spinner.show();
    this.api.API_POST_bloquearUsuario(row.idPersonaPeriodo, "us_persona").subscribe((response: ResponseOtrasCuentasModel) => {
        this.spinner.hide();
    },
    (err) => {
      console.log(err)
      alert(err)
      this.spinner.hide();
    })
  } 

  seleccionarRegion(value){
    this.idRegion = value;
    const indexRegion =this.infoSelectJardin.regiones.map(element => element.idRegion).indexOf(value);
    this.arrayComunas = this.infoSelectJardin.regiones[indexRegion].comunas;
    this.callData(null);
  }

  seleccionarComuna(value){
    this.idComuna = value;
    this.callData(null);
  }

  seleccionarPrograma(value){
    this.idPrograma = value;
    this.callData(null);
  }

  nombreRegion(id){
    const indexRegion =this.infoSelectJardin.regiones.map(element => element.idRegion).indexOf(id);
    return this.infoSelectJardin.regiones[indexRegion].nombre;
  }

  nombreComuna(idRegion,IdComuna){
    const indexRegion = this.infoSelectJardin.regiones.map(element => element.idRegion).indexOf(idRegion);
    const indexComuna = this.infoSelectJardin.regiones[indexRegion].comunas.map(element => element.idComuna).indexOf(IdComuna);
    return this.infoSelectJardin.regiones[indexRegion].comunas[indexComuna].nombre;
  }

  crearCuentaAsesor(){
    this.editar=false;
    this.encargadoRecionalModel = new EncargadoRegionalModel;
    this.modal.open(this.modalFromAsesorTecnico, { size: 'lg' });
  }


  guardar(){
    if(this.datosValidos()){
      this.encargadoRecionalModel.rut = formatRut(this.encargadoRecionalModel.rut);
      this.spinner.show();
      this.api.API_POST_guardarAsesorTecnico( this.encargadoRecionalModel).subscribe((response: any) => {
        
        this.spinner.hide();  
        this.close();
        this.getServerData();
      },
      (err) => {
        console.log(err)
        alert(err)
        this.spinner.hide();
      })
    }
  }
  
  datosValidos(){
    var valido = true;
    this.defaultValidation();
    if(!validateRut(formatRut(this.encargadoRecionalModel.rut))){
      valido = false;
      this.validacionRut=true;
    }
    if(this.encargadoRecionalModel.nombre.trim() == ""){
      valido = false;
      this.validacionNombres=true;
    }
    if(this.encargadoRecionalModel.apellidoPaterno.trim() == ""){
      valido = false;
      this.validacionApellido1=true;
    }
    if(this.encargadoRecionalModel.apellidoMaterno.trim() == ""){
      valido = false;
      this.validacionApellido2=true;
    }
    if(!this.validarCorreoElectronico(this.encargadoRecionalModel.email)){
      valido = false;
      this.validacionEmail=true;
    }
    if(this.encargadoRecionalModel.region.idRegion <= 0){
      valido = false;
      this.validacionRegion=true;
    }
    return valido;
  }

  close(){
    this.modal.dismissAll();
  }


  validarCorreoElectronico(correo: string): boolean {
    // Expresión regular para validar un correo electrónico
    const patronCorreoElectronico = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  
    // Usar la función test() para verificar si el correo coincide con el patrón
    return patronCorreoElectronico.test(correo);
  }

  defaultValidation(){
    this.validacionRut=false;
    this.validacionNombres=false;
    this.validacionApellido1=false;
    this.validacionApellido2=false;
    this.validacionEmail=false;
    this.validacionRegion=false;
  }
}

